module.exports = __webpack_public_path__ + "static/media/account_icon.3383f89c.svg";